import styles from "./index.module.scss";

export interface ListButtonProps
    extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    /**
     * Variant of the button to style it differently.
     * Can be "primary", "secondary", "tertiary", or "danger".
     */
    variant?: "primary" | "secondary" | "tertiary" | "danger";
}

export const ListButton = ({
    children,
    onClick,
    variant = "tertiary",
    ...props
}: ListButtonProps) => {
    return (
        <button
            {...props}
            className={`${styles["list-button"]} ${styles[variant]}`}
            onClick={onClick}
        >
            <h6>{children}</h6>
        </button>
    );
};
